import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-link-underline__content" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-navbar-badge _ml-1",
  "data-qa": "project-navigation-badge"
}
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = { class: "gfu-link-underline__content" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-navbar-badge _ml-1",
  "data-qa": "project-navigation-badge"
}
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = { class: "gfu-link-underline__content" }
const _hoisted_9 = {
  key: 0,
  class: "gfu-navbar-badge _ml-1",
  "data-qa": "project-navigation-badge"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.tag), {
    href: $options.href,
    url: $options.href,
    class: _normalizeClass(['gfu-navbar-item gfu-link-underline', { 'is-active': $props.link.isActive }])
  }, {
    default: _withCtx(() => [
      ($props.link.isRestricted && $props.link.canBypassRestriction)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            tag: "div",
            text: $props.link.restrictionReason,
            theme: "light",
            "use-native-click": true,
            "vertical-position": "down",
            class: "gfu-navbar-tooltip"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "gfu-navbar-link gfu-navbar-link--disabled",
                "data-qa": `project-navigation-link:${$props.link.name}`
              }, [
                _createElementVNode("span", _hoisted_2, _toDisplayString($props.link.name), 1 /* TEXT */),
                ($props.link.badgeText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.link.badgeText), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_1)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text"]))
        : ($props.link.isRestricted && !$props.link.canBypassRestriction)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 1,
              text: $props.link.restrictionReason,
              theme: "light",
              "vertical-position": "down"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "gfu-navbar-link gfu-navbar-link--disabled _pen",
                  "data-qa": `project-navigation-link:${$props.link.name}`
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString($props.link.name), 1 /* TEXT */),
                  ($props.link.badgeText)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($props.link.badgeText), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_4)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "gfu-navbar-link",
              "data-qa": `project-navigation-link:${$props.link.name}`
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString($props.link.name), 1 /* TEXT */),
              ($props.link.badgeText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($props.link.badgeText), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_7))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["href", "url", "class"]))
}